import type { ReactNode } from 'react';

import './CenteredPage.css';

export interface CenteredPageProps {
  /** The product mark above the panel: a Logo. */
  brand: ReactNode;
  /** The page's one h1. */
  title: string;
  description?: ReactNode;
  children?: ReactNode;
  /** Small print under the panel: the language switcher, a support link. */
  footer?: ReactNode;
}

/**
 * CenteredPage is a single focused panel in the middle of the screen, for
 * pages outside the console frame: sign in, session expired, not found. One
 * task, nothing to navigate away to.
 */
export function CenteredPage({ brand, title, description, children, footer }: CenteredPageProps) {
  return (
    <main className="rs-centered-page">
      <div className="rs-centered-page__column">
        <p className="rs-centered-page__brand">{brand}</p>
        <section className="rs-centered-page__panel" aria-labelledby="rs-centered-page-title">
          <div className="rs-centered-page__heading">
            <h1 id="rs-centered-page-title" className="rs-centered-page__title">
              {title}
            </h1>
            {description ? <p className="rs-centered-page__description">{description}</p> : null}
          </div>
          {children}
        </section>
        {footer ? <div className="rs-centered-page__footer">{footer}</div> : null}
      </div>
    </main>
  );
}
